import { downloadBalanceListComponent } from './downloadBalanceList.component';

export const downloadBalanceListStateName = 'app.ticket.downloadBalanceList';

export const downloadBalanceListState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: downloadBalanceListStateName,
    url: '/downloadBalanceList',
    component: downloadBalanceListComponent.name,
    data: { requiresAuth: true }
  });
};
